export default function isPreview() {
  const params = new URLSearchParams(window.location.search);
  return params.get('preview') !== null;
}
